module.exports = __webpack_public_path__ + "img/group.ae797995.svg";